import React from 'react';
import { Box, Typography } from '@mui/material';

export const InventoryAnalytics: React.FC = () => {
  return (
    <Box>
      <Typography variant="h6">Analytics Dashboard</Typography>
      <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
        Coming soon: Inventory trends, turnover analysis, and predictive analytics
      </Typography>
    </Box>
  );
};

export const LowStockItems: React.FC<{ items: any[] }> = ({ items }) => {
  return (
    <Box>
      <Typography variant="h6">Low Stock Items ({items.length})</Typography>
      <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
        Items below reorder level will be displayed here
      </Typography>
    </Box>
  );
};

export const ExpiringProducts: React.FC<{ items: any[] }> = ({ items }) => {
  return (
    <Box>
      <Typography variant="h6">Expiring Products ({items.length})</Typography>
      <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
        Beauty products expiring within 90 days will be displayed here
      </Typography>
    </Box>
  );
};
